export const INVOICE_DEADLINE_TYPES = {
  BEFORE_SLOT: 'before_slot',
  AFTER_CREATION: 'after_creation'
}
